module.exports = __webpack_public_path__ + "img/usersandgroups.e5edd627.svg";